import { createGlobalStyle } from 'styled-components';

/**
 * global styles are coming from Material UI
 * here we are adding more to fine tune to our liking
 */
export const GlobalStyle = createGlobalStyle``;
